// Data-layers glyph rendered in the AirspaceCard title row when the card is a
// LAANC grid advisory with an airport code. Paths and fills copied verbatim
// from the design handoff prototype (32×32, viewBox 0 0 24 24).
import type { ReactElement } from 'react';

import styles from './styles.module.scss';

const LAANC_ICON_SIZE = '32';

const LaancIcon = (): ReactElement => (
    <svg
        aria-label='Data layers'
        className={styles.laancIcon}
        height={LAANC_ICON_SIZE}
        viewBox='0 0 24 24'
        width={LAANC_ICON_SIZE}
        xmlns='http://www.w3.org/2000/svg'>
        <rect fill='#aecbfa' height='4.64' width='1.5' x='11.25' y='4.1' />

        <path
            d='M12,20.8,2.25,14.32,12,7.84l9.75,6.48ZM5,14.32,12,19l7-4.68L12,9.64Z'
            fill='#669df6'
        />

        <path d='M12,16.16,2.25,9.68,12,3.2l9.75,6.48ZM5,9.68l7,4.68,7-4.68L12,5Z' fill='#aecbfa' />

        <path d='M18.26,12,12,7.84,5.74,12,12,16.16Z' fill='#4285f4' />
    </svg>
);

export default LaancIcon;
